/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// Material Dashboard 2 PRO React TS Base Styles
import typography from 'assets/theme/base/typography'
import { formatCompactNumber, formatPercentage } from 'utils/formatNumber'

interface StackOptions {
	stacked?: boolean
	percentage?: boolean
	totals?: number[]
}

function configs(
	labels: any,
	datasets: any,
	{ stacked = false, percentage = false, totals }: StackOptions = {}
) {
	const stackedPlugins = stacked
		? {
				tooltip: {
					itemSort: (a: any, b: any) => b.datasetIndex - a.datasetIndex,
					callbacks: {
						label: (ctx: any) =>
							`${ctx.dataset.label}: ${
								percentage ? formatPercentage(ctx.parsed.y) : formatCompactNumber(ctx.parsed.y)
							}`,
						footer: (items: any[]) =>
							totals && items.length
								? `Total: ${formatCompactNumber(totals[items[0].dataIndex])}`
								: '',
					},
				},
		  }
		: {}

	return {
		data: {
			labels,
			datasets: [...datasets],
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			...(stacked && { interaction: { intersect: false, mode: 'index' } }),
			plugins: {
				legend: {
					display: false,
				},
				...stackedPlugins,
			},
			scales: {
				y: {
					stacked,
					...(percentage && { min: 0, max: 100 }),
					grid: {
						drawBorder: false,
						display: true,
						drawOnChartArea: true,
						drawTicks: false,
						borderDash: [5, 5],
						...(stacked && { color: '#c1c4ce5c' }),
					},
					ticks: {
						display: true,
						padding: 10,
						color: '#9ca2b7',
						...(stacked && {
							precision: 0,
							callback: (value: number | string) =>
								percentage ? `${value}%` : formatCompactNumber(Number(value)),
						}),
						...(percentage && { stepSize: 20 }),
						font: {
							size: 11,
							family: typography.fontFamily,
							style: 'normal',
							lineHeight: 2,
						},
					},
				},
				x: {
					stacked,
					grid: {
						drawBorder: false,
						display: false,
						drawOnChartArea: true,
						drawTicks: true,
					},
					ticks: {
						display: true,
						color: '#9ca2b7',
						padding: 10,
						font: {
							size: 11,
							family: typography.fontFamily,
							style: 'normal',
							lineHeight: 2,
						},
					},
				},
			},
		},
	}
}

export default configs
